/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Action } from '@ngrx/store';
import { Label } from './labels.models';
import { type } from '../../shared/util';

export const LabelActionTypes = {
  LABELS_GET_LABELS: type("[Label] Get Labels asdf"),
  LABELS_GET_LABELS_SUCCESS: type("[Label] Get Labels Success"),
  LABELS_GET_LABELS_FAIL: type("[Label] Get Labels Fail"),
  LABELS_UPDATE_LABELS: type("[Label] Update Labels"),
  LABELS_UPDATE_LABELS_SUCCESS: type("[Label] Update Labels Success"),
  LABELS_UPDATE_LABELS_FAIL: type("[Label] Update Labels Fail"),
  LABELS_RESET: type("[Label] Reset"),
};

export class GetLabels implements Action {
  type = LabelActionTypes.LABELS_GET_LABELS;

  constructor() { }
}

export class GetLabelsSuccess implements Action {
  type = LabelActionTypes.LABELS_GET_LABELS_SUCCESS;

  constructor(public payload: Label[]) { }
}

export class GetLabelsFail implements Action {
  type = LabelActionTypes.LABELS_GET_LABELS_FAIL;

  constructor(public payload: Object) { }
}

export class UpdateLabels implements Action {
  type = LabelActionTypes.LABELS_UPDATE_LABELS;

  constructor(public payload: Label[]) { }
}

export class UpdateLabelsSuccess implements Action {
  type = LabelActionTypes.LABELS_UPDATE_LABELS_SUCCESS;

  constructor(public payload: Object) { }
}

export class UpdateLabelsFail implements Action {
  type = LabelActionTypes.LABELS_UPDATE_LABELS_FAIL;

  constructor(public payload: Object) { }
}

export class ResetLabelsAction implements Action {
    type = LabelActionTypes.LABELS_RESET;

    constructor() { }
  }

export type KlassenbuchActions =
    GetLabels
    | GetLabelsSuccess
    | GetLabelsFail
    | UpdateLabels
    | UpdateLabelsSuccess
    | UpdateLabelsFail
    | ResetLabelsAction;


